module.exports = __webpack_public_path__ + "img/read-more-side.daf63d0e.svg";